export default __webpack_public_path__ + "static/media/pd4.912a1cee.jpg";